import { JobOutcome } from "../../../../../services/job-outcomes-api";
import { formatMinutes } from "../../../line-activities/utils/line-activities";

export type OutcomeTone = "success" | "warning" | "danger" | "info";

/** What a job card says about what happened to its order. */
export interface OutcomeMark {
	tone: OutcomeTone;
	text: string;
	/** The order is late and its line has not been moved on yet: offer "Update schedule". */
	needsUpdate: boolean;
}

/**
 * The card's mark: done; partly done (how much is left, until the schedule is
 * updated); not done (until updated — then a rerun follows it); or, for an order
 * Update schedule made, the rest of a partial job or the rerun of one not done
 * (from the outcome of the order it follows). Null when nothing was recorded.
 */
export function outcomeMark(outcome: JobOutcome | undefined, follows?: JobOutcome): OutcomeMark | null {
	if (!outcome && follows) {
		return { tone: "info", text: follows.outcome === "notCompleted" ? "↻ Rerun" : "↻ Rest of the batch", needsUpdate: false };
	}
	if (!outcome) return null;
	const updated = Boolean(outcome.rescheduledAt);
	switch (outcome.outcome) {
		case "completed":
			return { tone: "success", text: "✓ Done", needsUpdate: false };
		case "partial":
			return updated
				? { tone: "warning", text: "Partly done · rest moved", needsUpdate: false }
				: { tone: "warning", text: `Partly done · ${formatMinutes(outcome.remainingMinutes ?? 0)} left`, needsUpdate: true };
		case "notCompleted":
			return { tone: "danger", text: updated ? "Not done · rerun planned" : "Not done", needsUpdate: !updated };
		default:
			return null;
	}
}
